import React, { useState, useEffect } from 'react';
import { TextField, Button, Container, Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { apiFetch } from '../utils/api';

function Profile() {
  const [user, setUser] = useState({
    username: '',
    email: '',
    password: '',  // Agregar el campo password
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    // Aquí harías una llamada a la API para obtener los datos del perfil del usuario
    async function fetchUserProfile() {
      try {
        const response = await apiFetch('/api/users/me');
        const data = await response.json();
        if (response.ok) {
          setUser({ ...data }); // No mostrar el password en el campo
          setLoading(false);
        } else {
          setError('Error al cargar los datos del perfil');
        }
      } catch (err) {
        setError('Error al conectar con el servidor');
      }
    }

    fetchUserProfile();
  }, []);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Clonar el usuario para evitar enviar un password vacío
    const userToUpdate = { ...user };

    // Si el campo password está vacío, eliminarlo del objeto a enviar
    if (userToUpdate.password === '') {
      delete userToUpdate.password;
    }

    try {
      const response = await apiFetch('/api/users/me', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(userToUpdate),
      });

      const data = await response.json();
      if (response.ok) {
        setSuccess('Perfil actualizado con éxito');
      } else {
        setError(data.message || 'Error al actualizar el perfil');
      }
    } catch (err) {
      setError('Error al conectar con el servidor');
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', margin: '20px auto' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <Container>
      <Box
        sx={{
          mt: 4,
          p: 3,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
        }}
      >
        <Typography variant="h4" gutterBottom>
          Perfil de Usuario
        </Typography>
        {error && <Typography color="error">{error}</Typography>}
        {success && <Typography color="primary">{success}</Typography>}
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label="Nombre de Usuario"
            name="username"
            value={user.username}
            onChange={handleChange}
            required
          />
          <TextField
            fullWidth
            margin="normal"
            label="Correo Electrónico"
            name="email"
            type="email"
            value={user.email}
            onChange={handleChange}
            required
          />
          <TextField
            fullWidth
            margin="normal"
            label="Contraseña"
            name="password"
            type="password"
            value={user.password}
            onChange={handleChange}
            placeholder="Dejar en blanco para mantener la misma contraseña"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
          >
            Guardar Cambios
          </Button>
        </form>
      </Box>
    </Container>
  );
}

export default Profile;
